/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
function openPopup() {
  document.getElementById("popupOverlay").classList.add('active');
  document.querySelector('html').setAttribute('data-scroll-locked','')
}
function closePopup() {
  document.getElementById("popupOverlay").classList.remove('active');
  document.querySelector('html').removeAttribute('data-scroll-locked')
}
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('[data-accordion-holder]').forEach( accordionHolder => {
    const aHeadings = accordionHolder.querySelectorAll('[data-accordion-toggle]')
    console.log(aHeadings)
    console.log(accordionHolder)
    aHeadings.forEach(aHeading => {
      aHeading.addEventListener('click', () => {
        if(aHeading.classList.contains('is-open')) {
          aHeading.classList.remove('is-open')
          aHeading.nextElementSibling.style.height = 0
        }else {
          if(accordionHolder.querySelector('.is-open[data-accordion-toggle]')){
            accordionHolder.querySelector('.is-open[data-accordion-toggle]').nextElementSibling.style.height = 0;
            accordionHolder.querySelector('.is-open[data-accordion-toggle]').classList.remove('is-open')
          }
          aHeading.classList.add('is-open')
          aHeading.nextElementSibling.style.height = `${aHeading.nextElementSibling.scrollHeight}px`;
        }
      })
    });
  })
});

$( document ).ready(function() {


$( ".colect-title" ).on( "click", function() {

    $(".colect-title").removeClass("active");
    $(".featured-div").removeClass("active");

        $(this).each(function() {
          $(this).addClass("active");
         

          if($(this).hasClass("collect-title1")){
            $(".product-two.featured-div").addClass("active");
          }
          else if($(this).hasClass("collect-title2")){
            $(".product-one.featured-div").addClass("active");
          }
        });
  });

  $( ".btn-feat" ).on( "click", function() {
    $('.custom--reformed-featured.pdp--featured .welcome--hover').addClass('active');
  } );

   $( ".custom--reformed-featured.pdp--featured .welcome--hover" ).on( "click", function() {
       $(this).removeClass('active');
  } );
    $( ".custom--reformed-forbes .slick-arrow" ).on( "click", function() {
        $(this).each(function() {
          var img_src = $(this).parents(".forbes-main").find('.slick-active img.brand').attr("src");
          $('.custom--reformed-forbes .forbes-icon img').attr('src',img_src);

        });
  } );

 var $slider_ingredients = $('.custom--reformed-ingredients .wrapper--full-padded .columns--mobile-slider');
    $slider_ingredients.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      centerMode: false,
      infinite: false,
      prevArrow:$('.custom--reformed-ingredients .prev-vids'),
      nextArrow:$('.custom--reformed-ingredients .next-vids'),
      responsive: [
        {
          breakpoint: 1180,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.3
          }
        }
      ]
  });
$(".product__icon__row").prev('.product__block.product__text').addClass('show');
$(".product__icon__row").next('.product__block.product__block--divider.divider-holder').addClass('show');
});

$(document).ready(function () {
  $(".open-call").on("click", function (e) {
    e.preventDefault();
      $(this).each(function() {
        $(this).closest(".product__content").find(".product__subheading > div").slideUp(700);
        if(!$(this).parents(".product__block.product__text").find(".open-call").hasClass('opened')) {
          $(this).parents(".product__block.product__text").find(".product__subheading > div").slideDown(700);
          $(this).closest(".product__content").find(".open-call").removeClass('opened closed');
          $(this).parents(".product__block.product__text").find(".open-call").addClass("opened closed");
          $(this).parents(".product__block.product__text").find(".open-call svg").animate({rotate: '45deg'});
        } else {
          $(this).closest(".product__content").find(".open-call").removeClass('opened closed');
          $(this).parents(".product__block.product__text").find(".open-call svg").animate({rotate: '0deg'});
        }

        $(this).parents(".product__block.product__text").find(".close-call").click(function () {
          $(this).parents(".product__block.product__text").find("#wrap").slideUp(700);
          $(this).parents(".product__block.product__text").find(".open-call").removeClass("opened closed");
          $(this).parents(".product__block.product__text").find(".open-call svg").animate({rotate: '0deg'});
        });

         $(this).parents(".product__block.product__text").find("#wrap").click(function () {
          $(this).parents(".product__block.product__text").find("#wrap").slideUp(700);
          $(this).parents(".product__block.product__text").find(".open-call").removeClass("opened closed");
          $(this).parents(".product__block.product__text").find(".open-call svg").animate({rotate: '0deg'});
        });
     });
  });
});

function newslSubmit(){
  const newslForm = document.querySelector('.footer__block--newsletter form[data-newsletter-form]');
  if(newslForm) {
  	newslForm.addEventListener('submit', function(){
  		newslForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
  	});
  }
}

function accordionToggleImg() {
  accordionDetailsToggle.forEach(toggle => {
    const accordionSection = toggle.closest('div[data-section-name="accordion-details"]');
    toggle.addEventListener('click', () => {
      const accordionImg = accordionSection.querySelector('.faq--img > img');
      accordionImg.src = toggle.dataset.imgSrc;
    })
  });
}

document.addEventListener('DOMContentLoaded', function() {

  function updateAccordion(item){
      let container = item.closest('.product_accordion')
      if(container == undefined || container == null ) return;
      if(container.classList.contains('open')) {
          container.classList.remove('open')
          container.querySelector('.product_accordion-container').style.height = '0px'
      }else{
          container.classList.add('open')
          container.querySelector('.product_accordion-container').style.height = `${container.querySelector('.product_accordion-content').scrollHeight}px`
      }
  }
  // Accordion
  let interVal = setInterval(()=> {

      if(document.querySelectorAll('.product_accordion-heading').length > 0) {
          document.querySelectorAll('.product_accordion-heading').forEach( item => {
              item.addEventListener('click',()=>{
                  updateAccordion(item)
              })
              item.addEventListener('touch',()=>{
                  updateAccordion(item)
              })
          })
          clearInterval(interVal)
      }
  },1000)

});


const accordionDetailsToggle = document.querySelectorAll('div[data-section-name="accordion-details"] [data-accordion-toggle]');

document.addEventListener("DOMContentLoaded", () => {
  $("video.connect-bg source").each(function() {
    var sourceFile = $(this).attr("data-src");
    $(this).attr("src", sourceFile);
    var video = this.parentElement;
    video.removeAttribute("controls");
    video.load();
    video.play();
  });
  accordionToggleImg();
  newslSubmit();
});

$( document ).ready(function() {
  // Add custom code below this line
  if ($(window).width() >= 800) {
      addEventListener('resize', function() {
            // $('.custom--reformed-ingredients .wrapper--full-padded .columns--mobile-slider').slick('refresh');
            $('.custom--reformed-benefits .wrapper--full-padded .columns--mobile-slider').slick('refresh');
            // $('.custom--reformed-ingredients .wrapper--full-padded .columns--mobile-slider').slick('resize');
            $('.custom--reformed-benefits .wrapper--full-padded .columns--mobile-slider').slick('resize');
            $('.custom--reformed-testimonials .col--reviews').slick('refresh');
            $('.custom--reformed-testimonials .col--video').slick('refresh');
      });
  }

$( ".colect-title" ).on( "click", function() {

    $(".colect-title").removeClass("active");
    $(".featured-div").removeClass("active");

        $(this).each(function() {
          $(this).addClass("active");
         

          if($(this).hasClass("collect-title1")){
            $(".product-two.featured-div").addClass("active");
          }
          else if($(this).hasClass("collect-title2")){
            $(".product-one.featured-div").addClass("active");
          }
        });
  });

  $( ".btn-feat" ).on( "click", function() {
    $('.custom--reformed-featured.pdp--featured .welcome--hover').addClass('active');
  } );

   $( ".custom--reformed-featured.pdp--featured .welcome--hover" ).on( "click", function() {
       $(this).removeClass('active');
  } );

/*   $( ".template-index .custom--reformed-det .accordion__title" ).on( "click", function() {
    $(".colect-title").removeClass("active");
    $(".featured-div").removeClass("active");

        $(this).each(function() {
          var img_src = $(this).parents(".accordion").find('img').attr("src");
          $('.custom--reformed-det .faq--img img').attr('src',img_src);

        });
  } ); */

    $( ".custom--reformed-forbes .slick-arrow" ).on( "click", function() {
        $(this).each(function() {
          var img_src = $(this).parents(".forbes-main").find('.slick-active img.brand').attr("src");
          $('.custom--reformed-forbes .forbes-icon img').attr('src',img_src);

        });
  } );

  if ($(window).width() <= 900 ) {
    // var $slider_ing= $('.custom--reformed-ingredients .wrapper--full-padded .columns--mobile-slider');

    // if ($slider_ing.length) {
    //   var currentSlide;
    //   var slidesCount;
    //   var sliderCounter = document.createElement('div');
    //   sliderCounter.classList.add('slider__countered');
      
    //   var updateSliderCounters = function(slick, currentIndex) {
    //     currentSlide = slick.slickCurrentSlide() + 1;
    //     slidesCount = slick.slideCount;
    //     $(sliderCounter).text(currentSlide + '/' +slidesCount)
    //   };

    //   $slider_ing.on('init', function(event, slick) {
    //     $slider_ing.append(sliderCounter);
    //     updateSliderCounters(slick);
    //   });

    //   $slider_ing.on('afterChange', function(event, slick, currentSlide) {
    //     updateSliderCounters(slick, currentSlide);
    //   });

    //   $slider_ing.slick({
    //     infinite: false,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     appendArrows: $('.custom--reformed-ingredients  .news__arrows'),
    //     prevArrow: '<div class="ing_prev news__arrow news__arrow_dir_left"></div>',
    //     nextArrow: '<div class="ing_next news__arrow news__arrow_dir_right"></div>',
		//     dots: false
    //   });
    //   $('.custom--reformed-ingredients .slider__countered').appendTo('.custom--reformed-ingredients .slider-counters');
    // }
      
    var $slider_ben= $('.custom--reformed-benefits .wrapper--full-padded .columns--mobile-slider');

    if ($slider_ben.length) {
      var currentSlide;
      var slidesCount;
      var sliderCounters = document.createElement('div');
      sliderCounters.classList.add('slider__countered');
      
      var updateSliderCounter = function(slick, currentIndex) {
        currentSlide = slick.slickCurrentSlide() + 1;
        slidesCount = slick.slideCount;
        $(sliderCounters).text(currentSlide + '/' +slidesCount)
      };

      $slider_ben.on('init', function(event, slick) {
        $slider_ben.append(sliderCounters);
        updateSliderCounter(slick);
      });

      $slider_ben.on('afterChange', function(event, slick, currentSlide) {
        updateSliderCounter(slick, currentSlide);
      });
      $slider_ben.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: $('.custom--reformed-benefits  .news__arrows'),
        prevArrow: '<div class="news__arrow news__arrow_dir_left"></div>',
        nextArrow: '<div class="news__arrow news__arrow_dir_right"></div>',
		    dots: false
      });
      
    $('.custom--reformed-benefits .slider__countered').appendTo('.custom--reformed-benefits .slider-counters');
    }
     var swiper = new Swiper(".mySwiper", {
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 10,
      loop: true
    });
 }
 var $slider_ingredients = $('.custom--reformed-ingredients .wrapper--full-padded .columns--mobile-slider');
    $slider_ingredients.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      centerMode: false,
      infinite: false,
      prevArrow:$('.custom--reformed-ingredients .prev-vids'),
      nextArrow:$('.custom--reformed-ingredients .next-vids'),
      responsive: [
        {
          breakpoint: 1180,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.3
          }
        }
      ]
  });
$(".product__icon__row").prev('.product__block.product__text').addClass('show');
$(".product__icon__row").next('.product__block.product__block--divider.divider-holder').addClass('show');
});

$(document).ready(function () {
  $(".open-call").on("click", function (e) {
    e.preventDefault();
      $(this).each(function() {
        $(this).closest(".product__content").find(".product__subheading > div").slideUp(700);
        if(!$(this).parents(".product__block.product__text").find(".open-call").hasClass('opened')) {
          $(this).parents(".product__block.product__text").find(".product__subheading > div").slideDown(700);
          $(this).closest(".product__content").find(".open-call").removeClass('opened closed');
          $(this).parents(".product__block.product__text").find(".open-call").addClass("opened closed");
          $(this).parents(".product__block.product__text").find(".open-call svg").animate({rotate: '45deg'});
        } else {
          $(this).closest(".product__content").find(".open-call").removeClass('opened closed');
          $(this).parents(".product__block.product__text").find(".open-call svg").animate({rotate: '0deg'});
        }

        $(this).parents(".product__block.product__text").find(".close-call").click(function () {
          $(this).parents(".product__block.product__text").find("#wrap").slideUp(700);
          $(this).parents(".product__block.product__text").find(".open-call").removeClass("opened closed");
          $(this).parents(".product__block.product__text").find(".open-call svg").animate({rotate: '0deg'});
        });

         $(this).parents(".product__block.product__text").find("#wrap").click(function () {
          $(this).parents(".product__block.product__text").find("#wrap").slideUp(700);
          $(this).parents(".product__block.product__text").find(".open-call").removeClass("opened closed");
          $(this).parents(".product__block.product__text").find(".open-call svg").animate({rotate: '0deg'});
        });
     });
  });
});

function newslSubmit(){
  const newslForm = document.querySelector('.footer__block--newsletter form[data-newsletter-form]');
  if(newslForm) {
  	newslForm.addEventListener('submit', function(){
  		newslForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
  	});
  }
}

function accordionToggleImg() {
  accordionDetailsToggle.forEach(toggle => {
    const accordionSection = toggle.closest('div[data-section-name="accordion-details"]');
    toggle.addEventListener('click', () => {
      const accordionImg = accordionSection.querySelector('.faq--img > img');
      accordionImg.src = toggle.dataset.imgSrc;
    })
  });
}


// if(!customElements.get('custom-accordion')){
//   class CustomAccordion extends HTMLElement {
//     constructor() {
//       super();
//         this.heading = this.querySelector('[accordion-heading]')
            
//         this.heading.addEventListener('click', function(){
//           alert()
//           let container = element.closest('accordion')
//           if(container == undefined || container == null ) return;
//           if(container.classList.contains('open')) {
//               container.classList.remove('open')
//               container.querySelector('[accordion-container]').style.height = '0px'
//           }else{
//               container.classList.add('open')
//               container.querySelector('[accordion-container]').style.height = `${container.querySelector('[accordion-content]').scrollHeight}px`
//           }
//       })
//     }
//   }
//   customElements.define('custom-accordion', CustomAccordion)
// }